module.exports = __webpack_public_path__ + "static/media/Firework.3a7f9313.png";